/* ======= Usage ==========
 * To add to a page, add the following script
 * natp.components.footer.create(selector);
 * ========================
*/

// Tell webpack to include your component specific css
require("./footer.css");

var create = function (containerSelector) {
	var component = {};
	component.container = document.querySelector(containerSelector);

	// Render the main guts of the component right away
	component.render = function (html) {
		if (component.container) {
			component.container.innerHTML = html;
		}
	};
// $.get('https://da79a07c.ngrok.io/assets/Style%20Library/_natptax/footer.html')
	$.get( _spPageContextInfo.siteAbsoluteUrl + '/Style%20Library/_natptax/footer.html')
		.then(component.render);

	return component;
};

module.exports = { create: create };


// WEBPACK FOOTER //
// ./src/scripts/components/footer/index.js